import SimpleSchema from 'simpl-schema'

// WARNING ! We must include uniforms to extend simpl-schema
// eslint-disable-next-line
import uniforms from 'uniforms'
import { Random } from 'meteor/random'
import CustomDate from '../components/modules/uniforms/material/CustomDate'

export const CONTRACT_STATUS = {
  TERMINATED: 'terminated',
  ONGOING: 'ongoing',
  CREATED: 'created',
  SUSPEND: 'suspend',
  SOLVED: 'solved', //customer deleted et contract facturé
}

export const CONTRACT_PAYMENT_TYPE = {
  EXTERNAL: 'externeApp',
  CB: 'cb',
  SEPA: 'sepa',
}

const schema = {
  _id: {
    type: String,
    uniforms: {
      component: () => null,
    },
    defaultValue: Random.id(),
  },
  customer: {
    label: 'Client',
    type: String,
    uniforms: {
      component: () => null, // that's ok!
    },
    optional: true,
  },
  date: {
    label: 'Date du contrat',
    type: Date,
    uniforms: {
      component: CustomDate,
    },
  },
  dateEnd: {
    label: 'Date de fin',
    type: Date,
    optional: true,
    uniforms: {
      component: CustomDate,
    },
  },
  offer: { label: 'Offre ', type: String, optional: true },
  lastDatePayed: {
    label: 'Date du dernier jour facturé',
    type: Date,
    optional: true,
    uniforms: {
      component: CustomDate,
    },
  },
  payment_type: {
    label: 'Type de paiement',
    type: String,
    allowedValues: Object.values(CONTRACT_PAYMENT_TYPE),
    optional: true,
  },
  status: {
    label: 'Status',
    type: String,
    allowedValues: Object.values(CONTRACT_STATUS),
  },
}

export default new SimpleSchema(schema)
